'use es6';

import { BASE_URI_LC } from '../constants/ApiConstants';
import { MarketingCategories, MarketingHubTools, SalesCategories, SalesHubTools, ServiceCategories, ServiceHubTools, WebCategories } from '../constants/TopFilterConstants';
export const TRACK_API_URL = `${BASE_URI_LC}/tracks`;
export function replaceCategoriesWithSubs(categories) {
  return categories.map(category => {
    if (category === 'MARKETING') {
      return MarketingCategories.toJS();
    }

    if (category === 'SALES') {
      return SalesCategories.toJS();
    }

    if (category === 'SERVICE' || category === 'SERVICE_SUPPORT') {
      return ServiceCategories.toJS();
    }

    if (category === 'WEB_DESIGN_DEVELOPMENT') {
      return WebCategories.toJS();
    }

    return category;
  }).flat();
}
export function replaceHubWithTools(tools) {
  return tools.map(tool => {
    if (tool === 'MARKETING_HUB_TOOLS') {
      return MarketingHubTools.toJS();
    }

    if (tool === 'SALES_HUB_TOOLS') {
      return SalesHubTools.toJS();
    }

    if (tool === 'SERVICE_HUB_TOOLS') {
      return ServiceHubTools.toJS();
    }

    return tool;
  }).flat();
}